module.exports = __webpack_public_path__ + "static/img/LEONARDO-LOMBARD.917af2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LEONARDO-LOMBARD.jpg
// module id = gZBv
// module chunks = 0